module.exports = __webpack_public_path__ + "static/media/img_4.5561c05e.png";